import Backbone from 'backbone';
import ko from 'knockout';
import _ from 'underscore';

import { ViewModel } from './url-input-viewmodel';
import urlInputTemplate from './url-input.pug';

export class UrlEditorView extends Backbone.View {
  initialize(options) {
    this.options = options || {};

    _.defaults(this.options, {
      template: urlInputTemplate,
      urlPlaceholder: '',
      errorContainer: '',
    });

    this.ko_model = new ViewModel(this.options);

    this.ko_model.fullUrl.subscribe((value) => {
      this.trigger('urlChanged', value);
    }, this);
  }

  render() {
    this.$el.html(this.options.template({
      urlPlaceholder: this.options.urlPlaceholder,
      ariaLabelledby: this.options.ariaLabelledby,
    }));

    ko.applyBindings(this.ko_model, this.el);
    return this;
  }

  remove() {
    ko.cleanNode(this.el);
    super.remove();
    return this;
  }

  getFullUrl() {
    return this.ko_model.fullUrl();
  }

  setFullUrl(url) {
    return this.ko_model.fullUrl(url);
  }

  enable() {
    this.ko_model.isDisabled(false);
  }

  disable() {
    this.ko_model.isDisabled(true);
  }
}
